var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPhoneVerification(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 21,
    viewBox: "0 0 14 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.75 3C0.75 2.33696 1.01339 1.70107 1.48223 1.23223C1.95107 0.763392 2.58696 0.5 3.25 0.5L10.75 0.5C11.413 0.5 12.0489 0.763392 12.5178 1.23223C12.9866 1.70107 13.25 2.33696 13.25 3V18C13.25 18.663 12.9866 19.2989 12.5178 19.7678C12.0489 20.2366 11.413 20.5 10.75 20.5H3.25C2.58696 20.5 1.95107 20.2366 1.48223 19.7678C1.01339 19.2989 0.75 18.663 0.75 18V3ZM8.25 16.75C8.25 16.4185 8.1183 16.1005 7.88388 15.8661C7.64946 15.6317 7.33152 15.5 7 15.5C6.66848 15.5 6.35054 15.6317 6.11612 15.8661C5.8817 16.1005 5.75 16.4185 5.75 16.75C5.75 17.0815 5.8817 17.3995 6.11612 17.6339C6.35054 17.8683 6.66848 18 7 18C7.33152 18 7.64946 17.8683 7.88388 17.6339C8.1183 17.3995 8.25 17.0815 8.25 16.75Z",
    fill: "#035C98"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneVerification);
export default __webpack_public_path__ + "static/media/phone-verification.cb1c71e1d2315487462b519a94d36ce4.svg";
export { ForwardRef as ReactComponent };